import style from './acx.module.scss';
import cls from 'classnames';
import facebbokSvg from '../../../assets/svg/facebook.svg';
import igSvg from '../../../assets/svg/ig.svg';
import { useIntl } from 'react-intl';
import { showAgreement as showAgreementDrawer } from '@/components/Drawer';

const ACXFooter = (props) => {
  const intl = useIntl();
  const { protocolList } = props;

  return (
    <div className={cls('h5-none pad-none', style.ACXFooter)}>
      <div className={style.footer_box}>
        {/* <div className={style.list_box}>
          <div className={cls(style.footer_item, style.margin_left_default)}>
            <div className={style.footer_tab}>{intl.formatMessage({ id: 'iWeb.components.Footer.acxCinemas', defaultMessage: 'acx院线' })}</div>
            <div className={style.footer_tab_content}>
              <ul className={style.footer_ul}>
                <li className={style.footer_li}>{intl.formatMessage({ id: 'iWeb.components.Footer.BusinessHours', defaultMessage: '营业时间' })}</li>
                <li className={style.footer_li}>{intl.formatMessage({ id: 'iWeb.components.Footer.LatestOffer', defaultMessage: '最新优惠' })}</li>
                <li className={style.footer_li}>{intl.formatMessage({ id: 'iWeb.components.Footer.AllMovies', defaultMessage: '全部电影' })}</li>
                <li className={style.footer_li}>{intl.formatMessage({ id: 'iWeb.components.Footer.StudioIntroduction', defaultMessage: '影厅介绍' })}</li>
              </ul>
            </div>
          </div>
          <div className={style.footer_item}>
            <div className={style.footer_tab}>{intl.formatMessage({ id: 'iWeb.components.Footer.Service', defaultMessage: '服务' })}</div>
            <div className={style.footer_tab_content}>
              <ul className={style.footer_ul}>
                <li className={style.footer_li}>{intl.formatMessage({ id: 'iWeb.components.Footer.Booking', defaultMessage: '预定' })}</li>
                <li className={style.footer_li}>{intl.formatMessage({ id: 'iWeb.components.Footer.PrivateScreening', defaultMessage: '私人放映' })}</li>
                <li className={style.footer_li}>{intl.formatMessage({ id: 'iWeb.components.Footer.PartyActivities', defaultMessage: '派对活动' })}</li>
              </ul>
            </div>
          </div>
        </div> */}
        <div className={style.footer_address}>
          <div className={style.footer_item}>
            <div className={style.footer_tab}>{intl.formatMessage({ id: 'iWeb.components.Footer.FollowUs', defaultMessage: '关注我们' })}</div>
            <div className={cls(style.footer_tab_content, style.address_warrper)}>
              <div className={style.other}>
                <a href="https://www.facebook.com/acx.cinemas.hk" target="_blank"><img src={facebbokSvg} alt="" className={style.other_img} /></a>
                <a href="https://www.instagram.com/acx.cinemas.hk" target="_blank"><img src={igSvg} alt="" className={style.other_img} /></a>
              </div>
              <div className={style.address_flex}>
                <span className={style.flex_left}>
                  <span className={style.address_icon} />
                </span>
                <span>{intl.formatMessage({ id: 'iWeb.components.Footer.acxAddress', defaultMessage: '香港北角渣華道 123號北角匯2期2樓 211 - 213號鋪' })}</span>
              </div>
              <div className={style.address_flex}>
                <span className={style.flex_left}>
                  <span className={style.email_icon} />
                </span>
                <span>info@acx-cinemas.com</span>
              </div>
              {
                protocolList?.length > 0 &&
                <div className={cls(style.address_flex, style.protocol)}>
                  {protocolList?.map((item, index) => {
                    return (
                      <span
                        onClick={() => {
                          showAgreementDrawer({
                            detail: item,
                          });
                        }}
                        key={index}
                        className={style.protocol_name}
                      >《{item?.title}》</span>
                    );
                  })}
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ACXFooter;